import { Box, Typography } from "@mui/material";
import React from "react";

interface Props {
  title: string;
  date?: string;
  badg?: string;
  status?: 0 | 1 | 2;
}

export default function StartStep({ title, badg, date, status }: Props) {
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "0px",
          right: "14px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          color={
            status === 0
              ? "info.main"
              : status === 1
              ? "secondary.main"
              : "success.main"
          }
          noWrap
          variant="body3"
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontFamily: "IrSans",
          }}
          noWrap
          variant="body10"
        >
          {date}
        </Typography>

        <Typography
          sx={{
            backgroundColor: "success.light",
            textAlign: "center",
            color: "success.main",
            fontSize: "6px",
          }}
        >
          {badg}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor:
            status === 0
              ? "info.light"
              : status === 1
              ? "secondary.main"
              : "success.main",
        }}
      ></Box>
      <Box
        sx={{
          width: "2px",
          backgroundColor: "info.main",
          height: "30px",
        }}
      ></Box>
    </Box>
  );
}
